import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combine class names, with Tailwind-aware conflict resolution.
 *
 * Usage:
 *   <div className={cn("p-4 text-text-primary", isActive && "bg-bg-subtle", className)} />
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
